<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer" style="min-height: 400px !important;">
          <div id="overlay" >
             <div class="loader"></div>
           </div>

          <div slot="header">
            <strong>Create Wrong Delivery Ticket</strong>
          </div>

          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group label="Rider ID : " :label-cols="3" >
                <v-select  v-model="deliveryagentid" :options="agentmaster" placeholder="Select Rider">
                </v-select>
             </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="6" >
              <b-form-group label="Shipment IDs : " :label-cols="3" >
                <vue-tags-input v-model="searchText" :tags="tags"
                  @tags-changed="newTags => tags = newTags" :avoidAddingDuplicates="false"
                  :placeholder="'Enter Shipping ID'" ref="taginput" v-bind:separators="[',', ';',' ']" 
                  />
              </b-form-group>
            </b-col>

          </b-row>

          <b-row>
            <b-col md="6" >
              <b-button  @click="getSubmittedRequestListing(1)" class="ml-2" size="md" variant="primary">Search</b-button>                
              <b-button  @click="clear" class="ml-2" size="md" variant="danger">Clear</b-button> 
              <b-button @click="submitTicketRequest" class="ml-2" size="md" variant="success" :disabled="!deliveryagentid || tags.length == 0"> Submit Ticket</b-button>       
            </b-col>
          </b-row>

          <b-row class="my-2"> 
            <b-col sm="12" class="text-right">     
                <b-col sm="12">  
                  <p> <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
                </b-col>
            </b-col> 

            <b-col sm="12">
              <b-table 
                show-empty 
                responsive
                :items="items" 
                :busy="isBusy" 
                :current-page="currentPage"
                :fields="fields" 
                :per-page="perPage" 
                :bordered="bordered"
              >
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>

                <template slot="status" slot-scope="row">
                  <div class="text-center">
                    <b-badge
                      :variant="(row.item.status === 'Approved') ? 'success' : (row.item.status === 'Rejected') ? 'danger' :  'warning'"
                      style="padding: 4px;">{{ row.item.status }}</b-badge>
                  </div>
                </template>

                <template slot="action" slot-scope="row">
									<div
										v-if="(row.item.status == 'Pending') && sysemailid == 'manoj.sadnani@firstcry.ae'" class="text-center">
										<b-button variant="outline-success" size="sm" class="mr-2"
											@click="toggleInfoModal(row.item, 'Approved')">
											Approve
										</b-button>
										<b-button variant="outline-danger" size="sm" class="mr-2"
											@click="toggleInfoModal(row.item, 'Rejected')">
											Reject
										</b-button>
									</div>
                  <div 
                    v-if="(row.item.status == 'Approved')" class="text-center">
                    <b-button variant="primary" size="sm" class="mr-2"
											@click="viewSettledDetails(row.item)">
											View
										</b-button>
                  </div>
								</template>

              </b-table>
            </b-col>

            <b-col sm="12" class="my-1" v-if="this.totalRows>10">
              <paginate 
                :page-count="noofpages"
                :page-range="10"
                :margin-pages="2"
                :click-handler="getSubmittedRequestListing"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :current-page="currentPage"
              >
              </paginate>
            </b-col>

            <b-modal size="md" title="Cash Already Received" v-model="cashModal" hide-footer>
              <div>
                <!-- <h4>Cash Already Received</h4> -->
                <p>Cash has already been received in the system for this shipment. Please enter an alternative shipment.</p>
              </div>
              <div class="text-right">
                <b-button @click="cashModal = false" class="ml-2" size="md" variant="secondary">Cancel</b-button> 
                <b-button @click="proceedToAddShipment()" class="ml-2" size="md" variant="primary">Proceed</b-button> 
              </div>
            </b-modal>

            <b-modal size="xl" v-model="alternateShipmentModal" hide-footer style="min-height: 700px !important;">
              <template #modal-title>
              <h5>{{ alternateModalType == 'submit' ? 'Proceed with Alternate Shipment' : 'Approved Request Details' }}</h5>
              </template>
              <b-row>
                <b-col sm="12">
                  <b-table
                    show-empty 
                    responsive 
                    :items="currentItems" 
                    :busy="isBusy1" 
                    :fields="currentFields" 
                    :bordered="bordered"
                  >

                    <div slot="table-busy" class="text-center text-danger my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>

                    <template slot="alternateshipments" slot-scope="row">
                      <div v-if="alternateModalType == 'submit'">
                        <b-form-group>
                          <ejs-multiselect id='multiselect' placeholder="Add Shipments" v-model="value2" :dataSource='options'  :showSelectAll='showSelectAll' selectAllText="Select All" unSelectAllText="unSelect All"    :fields='agentfields' :allowCustomValue='allowCustomValue' 
                          ></ejs-multiselect>                 
                        </b-form-group>
                      </div>
                      <div v-if="alternateModalType == 'details'">
                        <span>{{ row.item.alternateshipments }}</span>
                      </div>
                    </template>

                    <template slot="totalAmount" slot-scope="row">
                      {{ totalAmount }}
                    </template>

                    <template slot="pendingAmount" slot-scope="row">
                      {{ pendingAmount }}
                    </template>

                  </b-table>
                </b-col>
                <b-col sm="12" class="text-right" v-if="alternateModalType == 'submit'">     
                    <!-- <b-col sm="12">   -->
                    <b-button @click="approveRejectClearanceRequest('alternate')" class="ml-2" size="md" variant="primary" :disabled="pendingAmount > 0">Submit</b-button> 
                    <!-- </b-col> -->
                </b-col> 
              </b-row>
            </b-modal>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";
import Vue from 'vue';
import VueTagsInput from '@johmun/vue-tags-input';
export default {
  components: {
    VueTagsInput,
  },
  data: function () {
    return {
      deliveryagentid : '',
      agentmaster: [],
      tags:[],
      searchText:[],

      //table fields
      isBusy: false,
      items: [],
        //fields:[],
      fields: [
        {key:'deliveryagentmasterid',label:'Rider ID'},
        {key:'shippingid',label:'Shipment ID'},
        {key:'delivereddate',label:'Delivered Date'},
        {key:'shipmentamount',label:'Shipment Amount'},
        {key:'status',label:'Status'},
        {key:'action',label:'Action'},
      ],
      bordered: true,
      totalRows: 0,
      currentPage: 1,
      perPage:10,
      noofpages: 0,

      toggleInfo: false,
			valuedata: [],
			status: '',

      cashModal: false,
      alternateShipmentModal: false,

      currentItems: [],
      currentFields: [
        {key:'shippingid',label:'Current Shipment'},
        {key:'shipmentamount',label:'Current Shipment Amount'},
        {key:'alternateshipments',label:'Settle Shipments'},
        {key:'totalAmount',label:'Amount of Settle Shipments'},
        {key:'pendingAmount',label:'Pending Amount'},
        {key:'settled_shipment_pending',label:'Updated shipment COD collection value'},
      ],

      alternateShipmentData: [],
      alternateModalType: '',

      value2:[],
      agentfields: { text: 'name', value: 'id' },
      options: [],
      showSelectAll : true,
      allowCustomValue : true,

      totalAmount: 0,
      pendingAmount: 0,
      sysemailid: '',

    }
  },
  computed: {
    
  },

  watch: {
    value2: {
      handler(newVal) {
        this.calculateAmounts();
      },
      deep: true 
    },
    
    currentItems: {
      handler(newVal) {
        if (newVal && newVal.length > 0 && this.alternateModalType == 'submit') {
          this.pendingAmount = newVal[0].shipmentamount; 
          this.totalAmount = 0; 
        }
      },
      immediate: true 
    }
  },

  created: function () {
    var userdata = localStorage.getItem('userData')
    var userInfo = JSON.parse(userdata)
    this.sysemailid = userInfo.sysemailid;
    this.displaydeliveryagent();
    this.getSubmittedRequestListing(1);
  },

  methods: {
    displaydeliveryagent: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1',
        hub_id: userInfo.pickuplocationmasterid ? `${userInfo.pickuplocationmasterid}` : null,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.agentmaster = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.agentmaster = data;
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    getSubmittedRequestListing(pageNo){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      this.isBusy = true;

      var shipmentid = [];
      for(var i = 0; i < this.tags.length; i++) {
        shipmentid.push(this.tags[i].text);  
      }

      if(pageNo==1){
        this.items = [];
        this.totalRows = 0;
        this.noofpages = 0;
      }

      const obj = {
        deliveryagentmasterid: this.deliveryagentid ? this.deliveryagentid.key : null,
        hub_id:userInfo.pickuplocationmasterid ? userInfo.pickuplocationmasterid : null,
        shippingid: shipmentid,
        pageno: pageNo ? pageNo : 1,
        limit: this.perPage,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getWronglyDeliveredClearanceRequestListing`, obj)
      .then((result) => {
        this.isBusy = false;
        if (result.body.returnmsg === 'Successful') {
          this.items = result.body.returnvalue;
          this.totalRows = result.body.totalcount;
          this.noofpages=parseInt(this.totalRows)/this.perPage;
          this.noofpages=Math.ceil( this.noofpages);
          // console.log("noofpages-->",this.noofpages)
        }else{
          this.items = [];
          this.totalRows = 0;
          this.noofpages = 0;
          this.$fire({
            text: result.body.returnvalue,
            type: "warning",
            timer: 30000
          });
        }
      })
      .catch((ex) => {
        this.isBusy = false;
        // console.log('error', ex)
      })
    },

    submitTicketRequest(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)

      var shipmentid = [];
      for(var i = 0; i < this.tags.length; i++) {
        shipmentid.push(this.tags[i].text);  
      }

      const obj = {
        deliveryagentmasterid: this.deliveryagentid ? this.deliveryagentid.key : null,
        shippingid: shipmentid,
        actionby: userInfo.sysemailid,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/raiseWronglyDeliveredClearanceRequest`, obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000
            });
            this.clear();
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000
            });
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },

    validateAmountAlreadyCollectedOrNot(){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById("overlay").style.display = "block";

      const obj = {
        shippingid: this.valuedata.shippingid,
        deliveryagentmasterid: this.valuedata.deliveryagentmasterid
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/validateAmountAlreadyCollectedForShipment`, obj)
        .then((result) => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === 'Successful') {
            let data = result.body.returnvalue;
            if(data.codclosuredate){
              // console.log("cant continue")
              //call modal to add alternate shipment
              this.cashModal = true;
            }else{
              // console.log("continue")
              //call approve api
              this.approveRejectClearanceRequest('same');
            }
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000
            });
          }
        })
        .catch((ex) => {
          // console.log('error', ex)
          document.getElementById("overlay").style.display = "none";
        })
    },

    toggleInfoModal: function (value, status) {
			this.status = '';
			this.valuedata = [];
			this.valuedata = value;
			this.status = status;
      if(this.status == 'Approved'){
        this.validateAmountAlreadyCollectedOrNot();
      }else{
        this.approveRejectClearanceRequest('same');
      }
      
			// this.toggleInfo = !this.toggleInfo;
		},

    proceedToAddShipment(){
      this.currentItems = [];
      this.currentItems.push(this.valuedata);
      this.cashModal = false;
      this.alternateShipmentModal = true;
      this.alternateModalType = 'submit';
      this.value2 = []; 
      this.totalAmount = 0;
      this.pendingAmount = parseFloat(this.valuedata.shipmentamount);
      

      const obj = {
        deliveryagentmasterid: this.valuedata.deliveryagentmasterid
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDeliveredShipmentsOfRider`, obj)
        .then((result) => {
          if (result.body.returnmsg === 'Successful') {
            this.alternateShipmentData = result.body.returnvalue;

            // this.agentmaster = result.body;
            this.options=[]
            this.value2=[]

            for(var i = 0; i < this.alternateShipmentData.length; i++) {
              var shipmentsdata = {
                name: this.alternateShipmentData[i].shippingid + " - " + this.alternateShipmentData[i].collectablevalue  ,
                id: this.alternateShipmentData[i].shippingid
              }
              this.options.push(shipmentsdata);          
            }

          } else {
            this.alternateShipmentData = [];
            this.options=[];
            this.value2=[];
          }
        })
        .catch((ex) => {
          // console.log('error', ex)
        })
    },

    calculateAmounts() {
      let sumOfSelectedAmounts = 0;
      console.log("this.value2 (selected IDs)--->", this.value2);

      this.value2.forEach(selectedConsignmentId => {
        const selectedShipment = this.alternateShipmentData.find(
          shipment => shipment.shippingid == selectedConsignmentId
        );

        if (selectedShipment) {
          sumOfSelectedAmounts += parseFloat(selectedShipment.collectablevalue);
        } 
      });

      this.totalAmount = sumOfSelectedAmounts.toFixed(2);

      if (this.currentItems && this.currentItems.length > 0) {
        this.pendingAmount = (parseFloat(this.currentItems[0].shipmentamount) - this.totalAmount).toFixed(2);
        this.pendingAmount = this.pendingAmount < 0 ? 0 : this.pendingAmount;
      }
    },

    approveRejectClearanceRequest(settlewith){
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      document.getElementById("overlay").style.display = "block";

      
      if(settlewith=='same'){
        this.value2 = [];
      }

      var alternateshipmentid = [];
      for(var i = 0; i < this.value2.length; i++) {
        alternateshipmentid.push(this.value2[i]);  
      }

      const obj = {
        deliveryagentmasterid: this.valuedata.deliveryagentmasterid,
        shippingid: this.valuedata.shippingid,
        shipmentamount: this.valuedata.shipmentamount,
        actionby: userInfo.sysemailid,
        status: this.status,
        settlewith: settlewith,
        alternateshipmentid: alternateshipmentid
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/approveRejectWronglyDlvClearanceRequest`, obj)
        .then((result) => {
          document.getElementById("overlay").style.display = "none";
          if (result.body.returnmsg === 'Successful') {
            this.$fire({
              text: result.body.returnvalue,
              type: "success",
              timer: 30000
            });
            this.alternateShipmentModal = false;
            this.getSubmittedRequestListing(1);
          } else {
            this.$fire({
              text: result.body.returnvalue,
              type: "error",
              timer: 30000
            });
          }
        })
        .catch((ex) => {
          // console.log('error', ex)
          document.getElementById("overlay").style.display = "none";
        })
    },

    viewSettledDetails(value){
      // console.log("value--->", value);
      this.alternateShipmentModal = true;
      this.currentItems = [];
      this.pendingAmount = 0;
      this.alternateModalType = 'details';
      const obj = {
        shippingid: value.shippingid,
      }

      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getClearanceSettledDetails`, obj)
      .then((result) => {
        if (result.body.returnmsg === 'Successful') {
          this.currentItems = result.body.returnvalue;
          this.totalAmount = this.currentItems[0].shipmentamount;
          this.pendingAmount = 0;
        }else{
          this.alternateShipmentModal = false;
          this.currentItems = [];
          this.$fire({
            text: result.body.returnvalue,
            type: "error",
            timer: 30000
          });
        }
      })
      .catch((ex) => {
        // console.log('error', ex)
      })
    },

    clear: function() {
      this.tags = [],
      this.searchText = [],
      this.deliveryagentid = '';
      this.getSubmittedRequestListing(1)
    }  
  }
}
</script>

<style >
/* .vue-tags-input {
  width: 100% !important;
  box-sizing: border-box;
}

.vue-tags-input .ti-input {
  width: 100% !important;
  height: 10px !important;
  box-sizing: border-box;
}  */

</style>




